import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="final-cta" className="bg-forest py-20 md:py-32" data-id="element-26">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-28">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-warm-white mb-8" data-id="element-29">
            Tu Transformación Comienza Hoy
          </h2>

          <p className="text-xl md:text-2xl text-warm-white/90 mb-12 leading-relaxed" data-id="element-30">
            No esperes más. Tu cuerpo está listo para recuperar su equilibrio
            hormonal. Solo necesita las señales correctas.
          </p>

          <motion.a href="https://www.abeautifulage.com/cart/53764329210222:1" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full lg:w-auto bg-gold text-charcoal px-8 py-5 rounded-md text-base md:text-lg font-bold inline-flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-31">
            SÍ, QUIERO RECUPERAR MI CUERPO Y MI ENERGÍA — ACCESO INMEDIATO POR
            $7.39
            <ArrowRightIcon className="w-5 h-5" data-id="element-32" />
          </motion.a>

          <p className="text-warm-white/85 mt-8 text-sm" data-id="element-33">
            Acceso instantáneo • Garantía de 60 días • Sin riesgo
          </p>
        </motion.div>
      </div>
    </section>;
}